export const ServiceHost = 'https://service.commblom.xyz/api'